import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { DOWNLOAD_CAMPAIGN_RESULTS, LOAD_CAMPAIGN_STATISTICS } from "../../store/marketing/marketing-actions";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { GET_CAMPAIGN_STATISTICS } from "../../store/marketing/marketing-getters";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingCampaignStats",
  components: {
    SimpleButton
  },
  props: {
    campaignId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      emptyStats: {
        send: {
          label: "Send",
          count: 0,
          unique: 0,
          rate: 0
        },
        reject: {
          label: "Reject",
          count: 0,
          unique: 0,
          rate: 0
        },
        delivery: {
          label: "Delivery",
          count: 0,
          unique: 0,
          rate: 0
        },
        open: {
          label: "Open",
          count: 0,
          unique: 0,
          rate: 0
        },
        click: {
          label: "Click",
          count: 0,
          unique: 0,
          rate: 0
        },
        bounce: {
          label: "Bounce",
          count: 0,
          unique: 0,
          rate: 0
        },
        complaint: {
          label: "Complaint",
          count: 0,
          unique: 0,
          rate: 0
        },
        "rendering-failure": {
          label: "Rendering Failure",
          count: 0,
          unique: 0,
          rate: 0
        },
        unsubscribe: {
          label: "Unsubscribe",
          count: 0,
          unique: 0,
          rate: 0
        }
      },
      downloadingCSV: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("MarketingStore", [GET_CAMPAIGN_STATISTICS])), {}, {
    stats() {
      const campaignStats = this.GET_CAMPAIGN_STATISTICS(this.campaignId);
      return isEmpty(campaignStats) ? this.emptyStats : campaignStats;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("MarketingStore", [LOAD_CAMPAIGN_STATISTICS, DOWNLOAD_CAMPAIGN_RESULTS])), {}, {
    async downloadCSV() {
      this.downloadingCSV = true;
      await this.DOWNLOAD_CAMPAIGN_RESULTS({
        campaignId: this.campaignId
      });
      this.downloadingCSV = false;
    }
  })
});